import { gql } from "@apollo/client";

export const UPDATE_INVOICE_RECIPIENT = gql`
  mutation updateInvoiceRecipient($input: UpdateInvoiceRecipientInput!) {
    invoice {
      updateInvoiceRecipient(input: $input) {
        success
      }
    }
  }
`;
